import React, { createContext, useEffect, useState } from 'react';
import { dataStreamTypes, Run } from '../types'

interface UserSelectionContextType {
    selectedMoa: string
    selectedWeights: string
    selectedIndications: Set<string>
    focusedIndications: string
    streamsEnabled: { [key: string]: boolean }
    SetSelectedMoa: (moa: string) => void
    setSelectedWeights: (moa: string) => void
    SetSelectedIndications: (indications: Set<string>) => void
    SetFocusedIndications: (indication: string) => void
    setStreamEnabled: (d: { [key: string]: boolean }) => void
}

const UserSelectionContext = createContext<UserSelectionContextType | undefined>(undefined);

export const UserSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedMoa, SetSelectedMoa] = useState<string>(undefined);
    const [selectedWeights, setSelectedWeights] = useState<string>('A');
    const [selectedIndications, SetSelectedIndications] = useState<Set<string>>(new Set([]));
    const [focusedIndications, SetFocusedIndications] = useState<string>('');
    const [streamsEnabled, setStreamEnabled] = useState<{ [key: string]: boolean }>(Object.values(dataStreamTypes).reduce(
        (acc, key) => {
            acc[key] = true;
            return acc;
        }, {}))

    useEffect(() => {
        if (selectedIndications.size && !focusedIndications) {
            SetFocusedIndications(Array.from(selectedIndications)[0])
        } else if(!selectedIndications.has(focusedIndications)) {
            if(!selectedIndications.size) {
                SetFocusedIndications('')
            }
            else {
                SetFocusedIndications(Array.from(selectedIndications)[0])
            }
        }
    }, [selectedIndications])

    useEffect(() => { console.log(selectedWeights) }, [selectedWeights])

    return (
        <UserSelectionContext.Provider value={{
            selectedMoa, selectedIndications,
            streamsEnabled, selectedWeights, focusedIndications,
            SetSelectedMoa, setSelectedWeights, SetSelectedIndications,
            setStreamEnabled, SetFocusedIndications
        }}>
            {children}
        </UserSelectionContext.Provider>
    );
}

export default UserSelectionContext;
